enum ProductShelfProductLinkEnum {
	disabled = 'disabled',
	productInformationPage = 'productInformationPage',
	eventOnly = 'eventOnly'
}

export default ProductShelfProductLinkEnum;
